import UserStructureWithProfiles from "../Constants/UserProfileBlogStructure"; // Adjust path as needed

export const fetchUserProfileBlogMockData = async (profileName) => {
  try {
    const response = await fetch(
      `/api/mock/UserProfile/UserProfileBlogMockdata-${profileName.toLowerCase()}.json`
    );

    if (!response.ok) {
      throw new Error(`File not found`);
    }

    const data = await response.json();

    const formattedData = {
      ...UserStructureWithProfiles,

      profileName: data.profileName || profileName,
      profileId: data.profileId || `prof_${profileName.toLowerCase()}`,
      profileImage: data.profileImage || "", 
      profileUUID: data.profileUUID || `uuid-${profileName.toLowerCase()}`,
      userId: data.userId || "",
      lastAccessed: data.lastAccessed || "",
      bio: data.bio || "",
      supportedType: Array.isArray(data.supportedType) ? data.supportedType : [],
      profileType: data.profileType || "",

      connections: {
        friends: Array.isArray(data?.connections?.friends) ? data.connections.friends : [],
        admirer: Array.isArray(data?.connections?.admirer) ? data.connections.admirer : [],
      },

      created: data.created || "",
      updated: data.updated || "",

      blogs: Array.isArray(data.blogs)
        ? data.blogs.map((blog) => ({
            blogId: blog.blogId || "",
            blogUuid: blog.blogUuid || "",
            blogUrl: blog.blogUrl || "",
            title: blog.title || "",
            authorId: blog.authorId || "",
            authorName: blog.authorName || "",
            content: blog.content || "",
            tags: Array.isArray(blog.tags) ? blog.tags : [],
            createdAt: blog.createdAt || "",
            updatedAt: blog.updatedAt || "",
            publishedAt: blog.publishedAt || "",
            status: blog.status || "",
            thumbnailUrl: blog.thumbnailUrl || "",
            category: blog.category || "",
            commentsCount: blog.commentsCount || 0,
            likesCount: blog.likesCount || 0,
            sharesCount: blog.sharesCount || 0
          }))
        : [],

      audios: Array.isArray(data.audios) ? data.audios : [],
      videos: Array.isArray(data.videos) ? data.videos : [],
      images: Array.isArray(data.images) ? data.images : [],
      reels: Array.isArray(data.reels) ? data.reels : []
    };

    return formattedData;
  } catch (error) {
    console.error(`Failed to fetch profile mock data for ${profileName}:`, error.message);
    return null;
  }
};
